import React from 'react'
import { StyledDivProps } from '../types'
import { cn } from '../utils'

// 32px
export const H1 = ({ children, customClasses }: StyledDivProps) => (
  <h1
    className={cn(
      'mb-7 text-4xl font-bold leading-[1.44] text-default-lighter',
      customClasses
    )}
  >
    {children}
  </h1>
)

export const SubH1 = ({ children, customClasses }: StyledDivProps) => (
  <div
    className={cn(
      'text-xl font-normal leading-6 text-default-lighter',
      customClasses
    )}
  >
    {children}
  </div>
)

// 32px

export const H2 = ({ children, customClasses }: StyledDivProps) => (
  <h2
    className={cn(
      'mb-l text-xl leading-snug text-default-lighter sm:text-3xl sm:font-bold',
      customClasses
    )}
  >
    {children}
  </h2>
)

// 24px
export const H3 = ({ children, customClasses }: StyledDivProps) => (
  <h3
    className={cn(
      'mb-l text-2xl font-normal leading-snug text-default-lighter',
      customClasses
    )}
  >
    {children}
  </h3>
)

// 18px
export const H4 = ({ children, customClasses }: StyledDivProps) => (
  <h4
    className={cn(
      'mb-xxl text-xl font-normal leading-normal text-default-lighter',
      customClasses
    )}
  >
    {children}
  </h4>
)

// 18px
export const P = ({ children, customClasses }: StyledDivProps) => (
  <p
    className={cn(
      'text-xl font-normal leading-snug text-default-lighter',
      customClasses
    )}
  >
    {children}
  </p>
)
